import { HttpEvent, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApiUrlService } from '@app/shared/services/api-url.service';
import { Observable, switchMap, take } from 'rxjs';

import { SKIP_API_PREFIX } from './http-context';

function prefixRequest(
  request: HttpRequest<unknown>,
  apiUrlService: ApiUrlService,
  next: (request: HttpRequest<unknown>) => Observable<HttpEvent<unknown>>,
): Observable<HttpEvent<unknown>> {
  if (request.context.get(SKIP_API_PREFIX)) {
    return next(request);
  }

  return apiUrlService.getApiUrl$().pipe(
    take(1),
    switchMap((apiUrl) => next(request.clone({ url: `${apiUrl}api/v1/${request.url}` }))),
  );
}

/** Functional interceptor registered through provideHttpClient(). */
export const apiPrefixInterceptor: HttpInterceptorFn = (request, next) =>
  prefixRequest(request, inject(ApiUrlService), next);
